import React, { useState } from "react";
import { CgAddR } from "react-icons/cg";
import { BiTransferAlt } from "react-icons/bi";
import { TiUploadOutline } from "react-icons/ti";
import RecentTnxn from "./RecentTnxn";
import TransactionDetailsModal from "../activity/TransactionDetailsModal";
import ActivityDetailsModal from "../activity/ActivityDetailsModal";
import CoinGraph from "./CoinGraph";
import DepositModal from "./DepositModal";
import SwapCoin from "./SwapCoin";
import PreviewSwap from "./PreviewSwap";
import SwapSuccess from "./SwapSuccess";
import WithdrawCoin from "./withdraw/WithdrawCoin";
import WithdrawToBank from "./withdraw/WithdrawToBank";

import WithdrawToExAddy from "./withdraw/WithdrawToExAddy";
import SendToDeexTag from "./withdraw/SendToDeexTag";
import { BsArrowLeft } from "react-icons/bs";
import useUserAsset from "../../hooks/useUserAssets";
import { formatAmount } from "../../utils/formatTime";
import GetRates from "../../components/utils/GetRates";
import { useUser } from "../../context/user-context";
import { toast } from "react-hot-toast";
import ExWSuccess from "./withdraw/ExWSuccess";
import ExternalPreview from "./withdraw/ExternalPreview";
import DeexSuccess from "./withdraw/DeexSuccess";
import STDTpreview from "./withdraw/STDTpreview";
import { useMutation } from "@tanstack/react-query";
import { API } from "../../constants/api";
import { errorMessage } from "../../utils/errorMessage";
import useAuthAxios from "../../utils/baseAxios";
import { getDeviceInfo } from "../../utils/deviceInfo";

const CoinWallet = ({
  setOpenCoin,
  selectedCoinObj,
  setSelectedCoinObj,
}: any) => {
  const [openDeposit, setOpenDeposit] = useState<boolean>(false);
  const [openWithdraw, setOpenWithdraw] = useState<boolean>(false);
  const axiosInstance = useAuthAxios();
  const [openWithdrawPreviewEx, setOpenWithdrawPreviewEx] =
    useState<boolean>(false);

  const [openWithdrawBank, setOpenWithdrawBank] = useState<boolean>(false);
  const [openWithdrawExWallet, setOpenWithdrawExWallet] =
    useState<boolean>(false);
  const [openWithdrawDeex, setOpenWithdrawDeex] = useState<boolean>(false);
  const [openWithdrawDeexPreview, setOpenWithdrawDeexPreview] =
    useState<boolean>(false);
  const [openSwap, setOpenSwap] = useState<boolean>(false);
  const [openSwapPreview, setOpenSwapPreview] = useState<boolean>(false);
  const [openSwapSuccess, setOpenSwapSuccess] = useState<boolean>(false);
  const coinRate = GetRates(selectedCoinObj?.abbr?.toLowerCase());

  //swap
  const [selectedCoinToObj, setSelectedCoinToObj] = useState<any>(null);
  const [selectedCoinFromObj, setSelectedFromCoinObj] = useState<any>(null);
  const [recieveAmount, setReceiveAmount] = useState<string>("");
  const [feeAmount, setFeeAmount] = useState<string>("");
  const [orderID, setOrderID] = useState<string>("");
  const { walletBalanceInUsdt, loading } = useUserAsset();
  const [swapAmount, setSwapAmount] = useState<string>("");
  const { userDetails } = useUser();
  const deviceInfo = getDeviceInfo();
  //withdraw
  const [openSuccess, setOpenSuccess] = useState<boolean>(false);
  const [network, setNetwork] = useState<string>("");
  const [fee, setFee] = useState<string>("");
  const [exWalletAddy, setExWalletAddy] = useState<string>("");
  const [amount, setAmount] = useState<string>("");
  const [selectedCoinObjw, setSelectedCoinObjw] = useState<any>(null);

  //withdraw deex
  const [openDeexSuccess, setOpenDeexSuccess] = useState<boolean>(false);
  const [dtAmount, setDtAmount] = useState<string>("");
  const [selectedUser, setSelectedUser] = useState<any | null>(null);
  const [selectedDtCoinObj, setSelectedDtCoinObj] = useState<any>(null);
  const [selectedTransaction, setSelectedTransaction] = useState<any>(null);
  const [showReceipt, setShowReceipt] = useState<boolean>(false);
  const trackOpenSwap = async (data: any) => {
    const response = await axiosInstance.post(API.trackEvent, data);
    return response.data;
  };
  // console.log(userDetails);

  // console.log(deviceInfo);
  const completeTrackOpenSwap = useMutation({
    mutationFn: trackOpenSwap,
    onSuccess: (r) => {
      // toast.success(r.message);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });

  const handleTrackOpenSwap = () => {
    const data = {
      event: "CRYPTO__SWAP_STARTED",
      properties: {
        ip: "0.0.0.0",
        platform: "Web",
        deviceInfo: {
          name: deviceInfo.deviceName,
          uniqueId: deviceInfo.uniqueId,
          os: deviceInfo.operatingSystem?.family,
        },
      },
    };
    completeTrackOpenSwap.mutate(data);
  };

  return (
    <div className="w-full font-manrope lgss:px-16 xxl:px-24 xxxl:px-36 md:px-12 mds:px-8 px-4 flex flex-col lgss:flex-row gap-6">
      <div className="w-full lgss:w-1/2  lgss:mt-">
        <button
          onClick={() => {
            setSelectedCoinObj(null);
            setOpenCoin(false);
          }}
          className="flex items-center gap-2 mb-6 "
        >
          <BsArrowLeft className="dark:text-[#D8D8D8] text-gray-800 text-[14px]" />
        </button>
        <div className="w-full py-6 px-4 rounded-xl bg-white dark:bg-[#1C2227]">
          <div className="flex justify-start items-center gap-4 lgss:gap-2 ">
            <div className="w-[14px] h-[5px] bg-secondary_button  rounded-lg" />
            <h4 className="font-sora text-[13px] text-black dark:text-white">
              {selectedCoinObj?.abbr}
            </h4>
          </div>

          <div className="w-full flex-col items-center flex justify-center mt-4 gap-1">
            <h4 className="text-[13px] text-[#4E606E] dark:text-gray-300">
              Your total {selectedCoinObj?.abbr} Balance
            </h4>
            <h4 className="text-[18px] font-bold text-[#13181B] dark:text-gray-200 ">
              {loading
                ? "---"
                : `${formatAmount(
                    walletBalanceInUsdt[selectedCoinObj?.abbr.toLowerCase()] *
                      coinRate
                  )} NGN`}
            </h4>
            <h4 className="text-[13px] text-[#BE6B0A] font-semibold ">
              {loading
                ? "---"
                : `$${formatAmount(
                    walletBalanceInUsdt[selectedCoinObj?.abbr.toLowerCase()]
                  )}`}
            </h4>
          </div>
          <div className="w-full flex mt-6 items-center gap-3">
            <button
              onClick={() => {
                if (
                  !userDetails?.user?.wallets ||
                  userDetails?.user?.wallets?.length === 0
                ) {
                  toast.error(
                    "You don't have any wallet to deposit to, please refresh the page"
                  );
                } else {
                  setOpenDeposit(true);
                }
              }}
              className="bg-[#D4EBFD] w-1/3 text-[#0B75C2] text-[15px] font-semibold flex justify-center items-center gap-2 h-[44px] rounded-lg"
            >
              <CgAddR className="text-[16px]" />
              Deposit
            </button>
            <button
              onClick={() => {
                if (
                  !userDetails?.user?.wallets ||
                  userDetails?.user?.wallets?.length === 0
                ) {
                  toast.error(
                    "You don't have any wallet to withdraw from, please refresh the page"
                  );
                } else {
                  setOpenWithdraw(true);
                }
              }}
              className="bg-[#D4EBFD] w-1/3 text-[#0B75C2] text-[15px] font-semibold flex justify-center items-center gap-2 h-[44px] rounded-lg"
            >
              <TiUploadOutline className="text-[16px]" />
              Withdraw
            </button>
            <button
              onClick={() => {
                if (
                  !userDetails?.user?.wallets ||
                  userDetails?.user?.wallets?.length === 0
                ) {
                  toast.error(
                    "You don't have any wallet to swap from, please refresh the page"
                  );
                } else {
                  handleTrackOpenSwap();
                  setOpenSwap(true);
                }
              }}
              className="bg-[#D4EBFD] w-1/3 text-[#0B75C2] text-[15px] font-semibold flex justify-center items-center gap-2 h-[44px] rounded-lg"
            >
              <BiTransferAlt className="text-[16px]" />
              Swap
            </button>
          </div>
        </div>
        <RecentTnxn
          selectedCoinObj={selectedCoinObj}
          setSelectedTransaction={setSelectedTransaction}
        />
      </div>
      <div className="w-full lgss:w-1/2 pb-20 lgss:pb-0 mt-8 ">
        <CoinGraph selectedCoinObj={selectedCoinObj} />
      </div>
      {openDeposit && (
        <DepositModal
          setOpenDeposit={setOpenDeposit}
          selectedCoinObj={selectedCoinObj}
        />
      )}
      {openSwap && (
        <SwapCoin
          setOpenSwap={setOpenSwap}
          setOpenSwapPreview={setOpenSwapPreview}
          selectedCoinObjj={selectedCoinObj}
          selectedCoinToObj={selectedCoinToObj}
          setSelectedCoinToObj={setSelectedCoinToObj}
          selectedCoinFromObj={selectedCoinFromObj}
          setSelectedFromCoinObj={setSelectedFromCoinObj}
          recieveAmount={recieveAmount}
          setReceiveAmount={setReceiveAmount}
          setFeeAmount={setFeeAmount}
          setOrderID={setOrderID}
          amount={swapAmount}
          setAmount={setSwapAmount}
        />
      )}
      {openSwapPreview && (
        <PreviewSwap
          setOpenSwap={setOpenSwap}
          setOpenSwapPreview={setOpenSwapPreview}
          setOpenSwapSuccess={setOpenSwapSuccess}
          selectedCoinToObj={selectedCoinToObj}
          selectedCoinFromObj={selectedCoinFromObj}
          feeAmount={feeAmount}
          recieveAmount={recieveAmount}
          orderID={orderID}
          setOrderID={setOrderID}
          amount={swapAmount}
          setReceiveAmount={setReceiveAmount}
          setFeeAmount={setFeeAmount}
        />
      )}
      {openSwapSuccess && (
        <SwapSuccess
          setOpenSwapPreview={setOpenSwapPreview}
          setOpenSwapSuccess={setOpenSwapSuccess}
          setOpenSwap={setOpenSwap}
        />
      )}
      {openWithdraw && (
        <WithdrawCoin
          setOpenWithdraw={setOpenWithdraw}
          setOpenWithdrawBank={setOpenWithdrawBank}
          setOpenWithdrawExWallet={setOpenWithdrawExWallet}
          setOpenWithdrawDeex={setOpenWithdrawDeex}
        />
      )}
      {openWithdrawBank && (
        <WithdrawToBank
          setOpenWithdraw={setOpenWithdraw}
          setOpenWithdrawBank={setOpenWithdrawBank}
          selectedCoinObjj={selectedCoinObj}
        />
      )}
      {openWithdrawExWallet && (
        <WithdrawToExAddy
          setOpenWithdraw={setOpenWithdraw}
          selectedCoinObjj={selectedCoinObj}
          setOpenWithdrawExWallet={setOpenWithdrawExWallet}
          setOpenWithdrawPreviewEx={setOpenWithdrawPreviewEx}
          openWithdrawPreviewEx={openWithdrawPreviewEx}
          setNetwork={setNetwork}
          setFee={setFee}
          setExWalletAddy={setExWalletAddy}
          setAmount={setAmount}
          exWalletAddy={exWalletAddy}
          amount={amount}
          network={network}
          setSelectedCoinObjw={setSelectedCoinObjw}
          selectedCoinObjw={selectedCoinObjw}
        />
      )}

      {openWithdrawPreviewEx && (
        <ExternalPreview
          setOpenWithdrawExWallet={setOpenWithdrawExWallet}
          setOpenWithdrawPreviewEx={setOpenWithdrawPreviewEx}
          setOpenSuccess={setOpenSuccess}
          network={network}
          selectedCoinObjw={selectedCoinObjw}
          fee={fee}
          exWalletAddy={exWalletAddy}
          amount={amount}
        />
      )}
      {openSuccess && (
        <ExWSuccess
          setOpenSuccess={setOpenSuccess}
          network={network}
          setOpenWithdrawExWallet={setOpenWithdrawExWallet}
          wallet={exWalletAddy}
          amount={amount}
          selectedCoinObjw={selectedCoinObjw}
          fee={fee}
        />
      )}

      {openWithdrawDeex && (
        <SendToDeexTag
          setOpenWithdrawDeex={setOpenWithdrawDeex}
          setOpenWithdraw={setOpenWithdraw}
          selectedCoinObjj={selectedCoinObj}
          setOpenWithdrawDeexPreview={setOpenWithdrawDeexPreview}
          openWithdrawDeexPreview={openWithdrawDeexPreview}
          setSelectedUser={setSelectedUser}
          setSelectedCoinObj={setSelectedDtCoinObj}
          setAmount={setDtAmount}
          selectedUser={selectedUser}
          selectedCoinObj={selectedDtCoinObj}
          amount={dtAmount}
        />
      )}

      {openWithdrawDeexPreview && (
        <STDTpreview
          setOpenWithdrawDeex={setOpenWithdrawDeex}
          setOpenWithdrawDeexPreview={setOpenWithdrawDeexPreview}
          deexUser={selectedUser}
          amount={dtAmount}
          coin={selectedDtCoinObj}
          setOpenDeexSuccess={setOpenDeexSuccess}
        />
      )}
      {openDeexSuccess && (
        <DeexSuccess
          deexUser={selectedUser}
          amount={dtAmount}
          coin={selectedDtCoinObj}
          setOpenWithdrawDeex={setOpenWithdrawDeex}
          setOpenDeexSuccess={setOpenDeexSuccess}
        />
      )}
      {/* Two-step, matching the Activity page and the app. */}
      {selectedTransaction && !showReceipt && (
        <TransactionDetailsModal
          transaction={selectedTransaction}
          onClose={() => {
            setShowReceipt(false);
            setSelectedTransaction(null);
          }}
          onViewReceipt={() => setShowReceipt(true)}
        />
      )}
      {selectedTransaction && showReceipt && (
        <ActivityDetailsModal
          transaction={selectedTransaction}
          onClose={() => setShowReceipt(false)}
        />
      )}
    </div>
  );
};

export default CoinWallet;
